import { render, staticRenderFns } from "./MfaStatusBadge.vue?vue&type=template&id=6c13c9e7&scoped=true"
import script from "./MfaStatusBadge.vue?vue&type=script&lang=js"
export * from "./MfaStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./MfaStatusBadge.vue?vue&type=style&index=0&id=6c13c9e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13c9e7",
  null
  
)

export default component.exports